// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1MQN3","icon_container":"App_icon_container__3PxKI","empty_container":"App_empty_container__y0YEQ","text":"App_text__PPQbm"};